import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {ISearchInputRegion} from "../../search/components/ISearchInputValue";
import {ForYouModalStep} from "../types/ForYouModalStep";
import {IForYouAdditional} from "../types/IForYouAdditional";
import {IForYouCriteria} from "../types/IForYouCriteria";
import {IForYouModal} from "../types/IForYouModal";
import {IForYouUser} from "../types/IForYouUser";

const initialState: IForYouModal = {
    isModalOpen: false,
    step: ForYouModalStep.REGION,
    mainRegionName: "",
    regions: null,
    criteria: null,
    user: null,
    additional: null,
    isLoading: true,
    types: [],
    distance: 0
};

export const forYouModalSlice = createSlice({
    name: "forYouModal",
    initialState,
    reducers: {
        openForYouModal: (state, action: PayloadAction<number[]>) => {
            return {...initialState, isModalOpen: true, types: action.payload};
        },
        forYouModalNextStep: (state, action: PayloadAction<ForYouModalStep>) => {
            state.step = action.payload;
        },
        closeForYouModal: () => {
            return initialState;
        },
        setForYouMainRegion: (state, action: PayloadAction<string>) => {
            state.mainRegionName = action.payload;
        },
        setForYouRegion: (state, action: PayloadAction<{regions: ISearchInputRegion[]; distance: number}>) => {
            state.regions = action.payload.regions;
            state.distance = action.payload.distance;
        },
        setForYouCriteria: (state, action: PayloadAction<IForYouCriteria>) => {
            state.criteria = action.payload;
        },
        setForYouUser: (state, action: PayloadAction<IForYouUser>) => {
            state.user = action.payload;
        },
        setForYouAdditional: (state, action: PayloadAction<IForYouAdditional>) => {
            state.additional = action.payload;
        },
        setForYouModalLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        }
    }
});

export const {
    openForYouModal,
    forYouModalNextStep,
    closeForYouModal,
    setForYouModalLoading,
    setForYouCriteria,
    setForYouRegion,
    setForYouUser,
    setForYouAdditional,
    setForYouMainRegion
} = forYouModalSlice.actions;
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {ISearchInputRegion} from "../../search/components/ISearchInputValue";
import {ForYouModalStep} from "../types/ForYouModalStep";
import {IForYouAdditional} from "../types/IForYouAdditional";
import {IForYouCriteria} from "../types/IForYouCriteria";
import {IForYouModal} from "../types/IForYouModal";
import {IForYouUser} from "../types/IForYouUser";

const initialState: IForYouModal = {
    isModalOpen: false,
    step: ForYouModalStep.REGION,
    mainRegionName: "",
    regions: null,
    criteria: null,
    user: null,
    additional: null,
    isLoading: true,
    types: [],
    distance: 0
};

export const forYouModalSlice = createSlice({
    name: "forYouModal",
    initialState,
    reducers: {
        openForYouModal: (state, action: PayloadAction<number[]>) => {
            return {...initialState, isModalOpen: true, types: action.payload};
        },
        forYouModalNextStep: (state, action: PayloadAction<ForYouModalStep>) => {
            state.step = action.payload;
        },
        closeForYouModal: () => {
            return initialState;
        },
        setForYouMainRegion: (state, action: PayloadAction<string>) => {
            state.mainRegionName = action.payload;
        },
        setForYouRegion: (state, action: PayloadAction<{regions: ISearchInputRegion[]; distance: number}>) => {
            state.regions = action.payload.regions;
            state.distance = action.payload.distance;
        },
        setForYouCriteria: (state, action: PayloadAction<IForYouCriteria>) => {
            state.criteria = action.payload;
        },
        setForYouUser: (state, action: PayloadAction<IForYouUser>) => {
            state.user = action.payload;
        },
        setForYouAdditional: (state, action: PayloadAction<IForYouAdditional>) => {
            state.additional = action.payload;
        },
        setForYouModalLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        }
    }
});

export const {
    openForYouModal,
    forYouModalNextStep,
    closeForYouModal,
    setForYouModalLoading,
    setForYouCriteria,
    setForYouRegion,
    setForYouUser,
    setForYouAdditional,
    setForYouMainRegion
} = forYouModalSlice.actions;
